<template>
  <modal
    name="enterTableNumberModal"
    modal-style="compact"
    :display-header-title="false"
  >
    <enter-table-number />
  </modal>
</template>


<script>
  import EnterTableNumber from './enter-table-number/index.vue';


  export default {
    name: 'EnterTableNumberModal',

    components: {
      EnterTableNumber
    }
  };
</script>
